import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { useIntl } from 'react-intl'
import { useDiscussionRepository } from '../../../../../../services/adaptors/discussionRepositoryAdapter'
import {
  addGlobalMessage,
  MessageLevel,
} from '../../../../../../store/messages'

type UseDiscussionActionsProps = {
  versionPageUuid: string
  discussionUuid?: string
  onClose?: () => void
  onRefresh?: () => void | Promise<void>
}

export const useDiscussionActions = ({
  versionPageUuid,
  discussionUuid,
  onClose,
  onRefresh,
}: UseDiscussionActionsProps) => {
  const { createThread, createReply } = useDiscussionRepository()
  const dispatch = useDispatch()
  const intl = useIntl()

  const handleCreateThread = useCallback(
    async (content: string, targetUuids?: string[]) => {
      try {
        await createThread(
          versionPageUuid,
          content,
          discussionUuid,
          undefined, // メディアはTODOのためundefined
          targetUuids
        )
        onClose?.()
        await onRefresh?.()
      } catch (error) {
        dispatch(
          addGlobalMessage({
            type: MessageLevel.ERROR,
            title: intl.formatMessage({
              id: 'global.warning.systemError.server',
            }),
          })
        )
      }
    },
    [
      versionPageUuid,
      discussionUuid,
      createThread,
      onClose,
      onRefresh,
      dispatch,
      intl,
    ]
  )

  const handleCreateReply = useCallback(
    async (threadUuid: string, content: string, media?: string) => {
      try {
        await createReply(threadUuid, content, media)
        onClose?.()
        await onRefresh?.()
      } catch (error) {
        dispatch(
          addGlobalMessage({
            type: MessageLevel.ERROR,
            title: intl.formatMessage({
              id: 'global.warning.systemError.server',
            }),
          })
        )
      }
    },
    [createReply, onClose, onRefresh, dispatch, intl]
  )

  return {
    handleCreateThread,
    handleCreateReply,
  }
}
